var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ticket"},[_c('NavBar',{attrs:{"titleTranslationPath":"ticketPayment.title","back":"back"}}),_c('div',{ref:"content",staticClass:"content"}),_c('TabBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }